export const serializeStores = state => {
  const { basket, condition } = state
  return JSON.stringify({ basket, condition })
}
